import { MakeCall } from 'ha/services/apiV2/createMakeCall';

import { APIV2_URL } from './constants';
import {
  GetEngagementsQuery,
  GetEngagementsResponse,
} from './types/Engagement';

type UserId = number | 'me';

export default (makeCall: MakeCall) =>
  (
    userId: UserId = 'me',
    query?: GetEngagementsQuery,
  ): Promise<{ data: GetEngagementsResponse }> =>
    makeCall<GetEngagementsResponse>(
      'GET',
      `${APIV2_URL}/user/${userId}/tenants`,
      {
        query,
      },
    );
